import React from "react";
import { Helmet } from "react-helmet";
import homebackground from './../image/banner.png';

const TypicalRecruiter = () => {
  return (
    <div className="w-full h-auto bg-white flex flex-col items-center justify-center lg:mt-20 sm:mt-0">
      <Helmet>
        <title>Typical Recruiter | Nexify Infosystems</title>
        <meta name="description" content="Learn about the typical day of a recruiter at Nexify, including their morning planning, midday candidate management, afternoon collaboration, and end-of-day tasks." />
        <meta name="keywords" content="Recruiter, Careers, Nexify, Job Posting, Candidate Management" />
      </Helmet>
      <div
        className="w-full h-[440px] bg-cover bg-center relative flex items-center justify-center"
        style={{ backgroundImage: `url(${homebackground})` }}
      >
        <div className="relative z-0 flex justify-center lg:justify-start items-center w-full px-4 sm:px-10 lg:px-20">
          <div
            className="opacity-0 translate-y-10 animate-slideUp bg-[#0c5495b3] p-6 shadow-lg text-white inline-block text-center lg:text-left max-w-[90%] sm:max-w-[80%] md:max-w-[60%] lg:max-w-[60%] lg:ml-14"
            style={{
              animation: "slideUp 1s ease-in-out forwards",
              animationDelay: "2s",
            }}
          >
            <h1 className="text-[8vw] md:text-[66px] font-semibold mb-2 break-words">
              Nexify Typical Recruiter
            </h1>
            <h2 className="text-[5vw] md:text-[40px] text-[#efefef]">
              Finding the right fit, shaping careers, driving success.
            </h2>
          </div>
        </div>
      </div>
      <div className="w-full max-w-[1320px] px-4 mx-auto mt-20 mb-20">

        <h2 className="mb-6 text-[#0e55a8] lg:text-[40px] text-[30px] leading-[1.8] font-[700] text-left">Typical Recruiter</h2>
        {/* Content Section */}
        <div className="mt-5 text-gray-800 text-base leading-7">
          {/* Morning: Planning and Outreach */}
          <p className="mb-4 font-[400] text-[#222] leading-[1.8] text-[16px]">A typical day for a recruiter involves juggling multiple responsibilities to attract, screen, and hire the best talent for their organization or clients. Here’s a breakdown of what a day might look like:</p>
          <div className="mb-6">
            <p className="font-[700] text-[20px] text-[#222] mb-4">Morning: Planning and Outreach</p>
            <ul className="pl-5 list-[circle] mt-2">
              <li>
                <span className="text-[16px] text-[#6d6d70]">Review emails, messages, and priorities for the day</span>
              </li>
              <li>
                <span className="text-[16px] text-[#6d6d70]">Candidate Sourcing</span>
              </li>
              <li>
                <span className="text-[16px] text-[#6d6d70]">Job Postings and Promotions</span>
              </li>
            </ul>
          </div>
          <div className="mb-6">
            <p className="font-[700] text-[20px] text-[#222] mb-4">Midday: Candidate Management</p>
            <ul className="pl-5 list-[circle] mt-2">
              <li>
                <span className="text-[16px] text-[#6d6d70]">Conduct phone or video interviews to assess qualifications and fit.</span>
              </li>
              <li>
                <span className="text-[16px] text-[#6d6d70]">Send follow-ups and coordinate interviews with hiring managers.</span>
              </li>
              <li>
                <span className="text-[16px] text-[#6d6d70]">Build relationships with top talent for current and future opportunities.</span>
              </li>
            </ul>
          </div>
          <div className="mb-6">
            <p className="font-[700] text-[20px] text-[#222] mb-4">Afternoon: Collaboration and Strategy</p>
            <ul className="pl-5 list-[circle] mt-2">
              <li>
                <span className="text-[16px] text-[#6d6d70]">Meet with hiring managers to refine hiring strategies and align expectations.</span>
              </li>
              <li>
                <span className="text-[16px] text-[#6d6d70]">Update ATS with candidate progress and generate recruitment reports.
                </span>
              </li>
              <li>
                <span className="text-[16px] text-[#6d6d70]">Enhance skills through industry research, webinars, and networking.</span>
              </li>
            </ul>
          </div>
          {/* End of Day: Wrapping Up */}
          <div className="mb-6">
            <p className="font-[700] text-[20px] text-[#222] mb-4">End of Day: Wrapping Up</p>
            <ul className="pl-5 list-[circle] mt-2">
              <li>
                <span className="text-[16px] text-[#6d6d70]">Negotiate offers and finalize hiring decisions.</span>
              </li>
              <li>
                <span className="text-[16px] text-[#6d6d70]">Review progress, plan for the next day, and send follow-ups.</span>
              </li>
              <li>
                <span className="text-[16px] text-[#6d6d70]">Collaborate with the team to address challenges and refine strategies.</span>
              </li>
            </ul>
          </div>

          {/* Ongoing Tasks */}
          <div className="mt-10">
            <p className="font-[700] text-[20px] text-[#222] mb-4">Ongoing Tasks</p>
            <ul className="pl-5 list-[circle] mt-2">
              <li className="text-[16px] text-[#6d6d70] leading-[1.8]">Keeping up with recruitment trends and market insights.</li>
              <li className="text-[16px] text-[#6d6d70] leading-[1.8]">Maintaining relationships with hiring partners or agencies.</li>
              <li className="text-[16px] text-[#6d6d70] leading-[1.8]">Refining the employer brand to attract top talent.</li>
            </ul>
            <p className="text-[16px] text-[#6d6d70] leading-[1.8] mt-2">Recruiting is a dynamic and fast-paced job where no two days are exactly the same, requiring excellent organization, communication, and adaptability to succeed.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypicalRecruiter;
